<template>
  <div>
    <px-view-header title="Cadastro de solicitação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loadingForm">
      <px-circular-loading/>
    </div>
    <v-stepper class="elevation-1 rounded-card" v-if="!loadingForm" v-model="currentStep" vertical>

      <v-stepper-step :complete="currentStep > 1" step="1">Dados básicos</v-stepper-step>
      <v-stepper-content step="1">
        <px-cadastro-requisicao-dados-basicos :requisicao="requisicao"
                                              :campos-obrigatorios="camposObrigatorios"
                                              @next="next"
                                              @cancel="onClickCancelar"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 2" step="2">Produtos</v-stepper-step>
      <v-stepper-content step="2">
        <px-cadastro-requisicao-produtos-table :requisicao="requisicao"
                                               :is-edicao="isEdicao"
                                               :campos-obrigatorios="camposObrigatorios"
                                               :erp-campos-integracao="erpCamposIntegracao"
                                               @next="next"
                                               @previous="previous"
                                               @reset-fornecedor="resetFornecedor"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 3" step="3">Sugestão de fornecedores</v-stepper-step>
      <v-stepper-content step="3">
        <px-cadastro-requisicao-fornecedores v-if="currentStep === 3"
                                             :requisicao="requisicao"
                                             @resetfornecedor="resetFornecedor"/>
        <div class="button-div">
          <v-btn color="primary"
                 class="rounded-tag-small normal-btn-text elevation-0"
                :loading="loading"
                 @click="enviarRequisicao">
            Enviar
          </v-btn>
          <v-btn v-if="!isEdicao" @click="saveDraft"
              class="rounded-tag-small elevation-0 normal-btn-text ml-2">
            Salvar rascunho
          </v-btn>
          <v-btn text @click="previous" :disabled="loading" class="normal-btn-text">
            Voltar
          </v-btn>
        </div>
      </v-stepper-content>
    </v-stepper>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>
<script>
import CompradorService from '@/api/comprador-service';
import CadastroRequisicaoDadosBasicos
  from '@/modules/requisicao/cadastro/CadastroRequisicaoDadosBasicos.vue';
import { FinalidadeCompra, SituacaoRequisicao } from 'px-business-components';
import EntidadeCamposCompraService
  from '@/modules/erp-campos-obrigatorios/entidade-campos-requisicao-service';
import { mapGetters } from 'vuex';
import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';
import RequisicaoService from '../requisicoes-service';
import CadastroRequisicaoProdutosTable from './CadastroRequisicaoProdutosTable.vue';
import CadastroRequisicaoFornecedores from './CadastroRequisicaoFornecedores.vue';

export default {
  data() {
    return {
      isRascunho: this.$route.params.isRascunho,
      isCopy: this.$route.params.isCopy,
      idRequisicao: this.$route.params.id,
      loadingForm: false,
      loading: false,
      formDirty: true,
      camposObrigatorios: null,
      requisicao: {
        comprador: null,
        compradorEntrega: null,
        centroCusto: null,
        projeto: null,
        codigoInterno: null,
        urgencia: null,
        dataEntrega: null,
        observacaoInterna: null,
        observacaoExterna: null,
        finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
        arquivos: [],
        produtos: [],
        fornecedores: [],
      },
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Solicitações',
          to: '/requisicoes',
        },
        { text: 'Cadastro de solicitação' },
      ],
      currentStep: 1,
    };
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    confirmMessage() {
      return this.isRascunho ? 'Você deseja atualizar este rascunho?' : 'Você deseja salvar esta solicitação como rascunho?';
    },
    isEdicao() {
      return this.idRequisicao && !this.isRascunho && !this.isCopy;
    },
  },
  methods: {
    beforeWindowUnload(e) {
      if (this.formDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    next() {
      this.currentStep = this.currentStep + 1;
    },
    previous() {
      this.currentStep = this.currentStep - 1;
    },
    getCadastroAdicionalProduto(produto, tipo) {
      if (!produto.cadastrosAdicionais) {
        return {};
      }
      return getCadastroAdicional(produto.cadastrosAdicionais, tipo);
    },
    buildCadastrosAdicionaisProdutoPayload(produto) {
      if (!produto.cadastrosAdicionais || !produto.cadastrosAdicionais.armazem) {
        return [];
      }
      return [
        produto.cadastrosAdicionais.armazem || this.getCadastroAdicionalProduto(produto.produto, 'ARMAZEM'),
      ].map((cadastro) => {
        if (cadastro) {
          return {
            id: cadastro.id,
          };
        }
        return null;
      }).filter(cadastro => cadastro);
    },
    buildRequisicaoBody() {
      const requisicao = { ...this.requisicao };
      requisicao.produtos = requisicao.produtos
        .map(produto => ({
          ...produto,
          situacao: SituacaoRequisicao.keys.RECEBIDA.key,
          cadastrosAdicionais: this.buildCadastrosAdicionaisProdutoPayload(produto),
        }));
      return requisicao;
    },
    buildRequisicaoDraft() {
      const requisicao = { ...this.requisicao };
      requisicao.projeto = requisicao.projeto || null;
      requisicao.centroCusto = requisicao.centroCusto || null;
      requisicao.urgencia = requisicao.urgencia || null;
      requisicao.situacao = SituacaoRequisicao.keys.RASCUNHO.key;
      requisicao.produtos = requisicao.produtos
        .filter(produto => !!produto.unidadeMedida.id)
        .map(produto => ({
          ...produto,
          situacao: SituacaoRequisicao.keys.RASCUNHO.key,
          cadastrosAdicionais: this.buildCadastrosAdicionaisProdutoPayload(produto),
        }));
      return requisicao;
    },
    onClickBack() {
      if (this.isEdicao) {
        this.$router.push({ name: 'main.requisicoes' });
        return;
      }
      this.$refs.confirm.open(this.confirmMessage,
        'O rascunho ficara disponível na aba RASCUNHOS e TODAS da listagem de solicitações.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            this.$router.push({ name: 'main.requisicoes' });
            return;
          }
          this.saveDraft();
        });
    },
    onClickCancelar() {
      this.$router.push({ name: 'main.requisicoes' });
    },
    resetFornecedor() {
      this.requisicao.fornecedores = [];
    },
    createCopy(data) {
      const copia = {};
      Object.keys(this.requisicao)
        .forEach((key) => {
          copia[key] = data[key];
        });
      copia.situacao = SituacaoRequisicao.keys.RECEBIDA.key;
      copia.prazoEntrega = null;
      copia.validade = null;
      copia.codigoInterno = undefined;
      copia.produtos = copia.produtos.map(p => ({
        ...p,
        id: undefined,
        responsavel: undefined,
        dataPrevisaoEntrega: null,
        quantidade: p.quantidade,
        situacao: SituacaoRequisicao.keys.RECEBIDA.key,
        arquivos: p.arquivos || p.produto.arquivos || [],
        $$hasFileLoading: false,
      }));
      return copia;
    },
    enviarRequisicao() {
      this.loading = true;
      RequisicaoService.save(this.buildRequisicaoBody())
        .then(() => {
          this.$toast('Requisição enviada com sucesso', { color: 'success' });
          this.$router.push({ name: 'main.requisicoes' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveDraft() {
      this.loading = true;
      return RequisicaoService.saveRascunho(this.buildRequisicaoDraft())
        .then(() => {
          let message = 'Rascunho salvo com sucesso';
          if (this.idRequisicao && this.isRascunho) {
            message = 'Rascunho atualizado com sucesso';
          }
          this.$toast(message, { color: 'success' });
          this.$router.push({ name: 'main.requisicoes' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create(data) {
      if (this.isCopy) {
        this.requisicao = this.createCopy(data);
        return;
      }
      if (this.isRascunho) {
        this.requisicao = { ...data };
        return;
      }
      this.requisicao = { ...data };
    },
    getRequisicao() {
      this.loadingForm = true;
      return RequisicaoService.getRequisicao(this.idRequisicao)
        .then((response) => {
          this.create(response.data);
          return this.getComprador();
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    getComprador() {
      return CompradorService.getCompradorById(this.requisicao.comprador.id)
        .then(({ data }) => {
          this.requisicao.comprador = data;
        });
    },
    getCompradorDefaultFaturamento() {
      return CompradorService.getDefaultFaturamento()
        .then((response) => {
          this.requisicao.comprador = response.data;
        });
    },
    getCompradorDefaultEntrega() {
      return CompradorService.getDefaultEntrega()
        .then((response) => {
          this.requisicao.compradorEntrega = response.data;
        });
    },
    getCamposObrigatorios() {
      EntidadeCamposCompraService.getCamposObrigatorios(this.erpCamposIntegracao)
        .then((data) => {
          this.camposObrigatorios = data;
        });
    },
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
    this.getCamposObrigatorios();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  async mounted() {
    if (this.idRequisicao) {
      this.getRequisicao();
      return;
    }
    this.loadingForm = true;

    Promise.all([
      this.getCompradorDefaultEntrega(),
      this.getCompradorDefaultFaturamento(),
    ])
      .then(() => {
        this.loadingForm = false;
      });
  },
  components: {
    pxCadastroRequisicaoDadosBasicos: CadastroRequisicaoDadosBasicos,
    pxCadastroRequisicaoProdutosTable: CadastroRequisicaoProdutosTable,
    pxCadastroRequisicaoFornecedores: CadastroRequisicaoFornecedores,
  },
};
</script>
<style scoped>
.button-div {
  align-self: auto;
  margin-bottom: 2px;
}
</style>
